// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';

// Components
import Error from '../core/error';
import Loading from '../core/loading';
import Permissions from '../core/permissions';
import ProvidersForm from './providers-form';
import RecordDetails from '../core/record-details';

// Containers
import withForm from '../../containers/with-form';

// Styles
import './edit-provider.scss';

const formName = 'editProvider';

function EditProvider({resetForm, searchFetching, searchValues, searchValues: {providerId}}) {
    const getFormProps = () => ({
        className: 'edit-provider',
        editing: true,
        formName,
        onReset: (submitted, resetValues) => resetForm(submitted, resetValues, true),
    });

    const getRecordDetailsProps = () => ({
        blacklistKeys: ['providerId', 'version'],
        keyOrder: 'providers',
        searchData: [searchValues],
        whitelistKeys: ['partnerId', 'playerType', 'guid', 'dateCreated', 'createdBy', 'lastUpdated', 'lastModifiedBy'],
    });

    return (
        <Permissions
            accessRequirement="update"
            elementService="provider"
            notAuthorizedMessage={true}
            requiresServiceAccess={true}
        >
            {providerId ? (
                <div className="edit-provider">
                    <RecordDetails {...getRecordDetailsProps()} />
                    <ProvidersForm {...getFormProps()} />
                </div>
            ) : (
                <Error className="edit-provider--message" error="Select a provider from the list." />
            )}
            <Loading loading={searchFetching} />
        </Permissions>
    );
}

EditProvider.propTypes = {
    resetForm: PropTypes.func.isRequired,
    searchFetching: PropTypes.bool,
    searchValues: PropTypes.object,
};

export default withForm(EditProvider, formName);
